import React from 'react';
import { Camera, Radio, CloudLightning, MessageCircle } from 'lucide-react';

const QuickAccessTiles = ({ 
  onToggleCameras, 
  onOpenScanners, 
  onToggleWeather, 
  onOpenAiChat 
}) => {
  return (
    <div className="absolute top-[108px] left-1/2 -translate-x-1/2 z-18 hidden lg:flex gap-3 p-2">
      {/* Live Cameras Tile */}
      <button
        onClick={onToggleCameras}
        className="group flex items-center gap-3 px-5 py-3 rounded-xl bg-slate-900/90 backdrop-blur-sm border border-slate-700 hover:border-blue-500/50 hover:bg-slate-800/90 transition-all duration-200 shadow-lg hover:shadow-blue-500/10"
        data-testid="quick-access-cameras"
      >
        <div className="p-2 rounded-lg bg-blue-500/20 group-hover:bg-blue-500/30 transition-colors">
          <Camera className="w-5 h-5 text-blue-400" />
        </div>
        <div className="text-left">
          <div className="text-sm font-semibold text-slate-200">Live Cameras</div>
          <div className="text-xs text-slate-500">15,000+ DOT feeds</div>
        </div>
      </button>

      {/* Scanner Feeds Tile */}
      <button
        onClick={onOpenScanners}
        className="group flex items-center gap-3 px-5 py-3 rounded-xl bg-slate-900/90 backdrop-blur-sm border border-slate-700 hover:border-teal-500/50 hover:bg-slate-800/90 transition-all duration-200 shadow-lg hover:shadow-teal-500/10"
        data-testid="quick-access-scanners"
      >
        <div className="p-2 rounded-lg bg-teal-500/20 group-hover:bg-teal-500/30 transition-colors">
          <Radio className="w-5 h-5 text-teal-400" />
        </div>
        <div className="text-left">
          <div className="text-sm font-semibold text-slate-200">Scanner Feeds</div>
          <div className="text-xs text-slate-500">32 systems - 29 states</div>
        </div>
      </button>

      {/* Weather Alerts Tile */}
      <button
        onClick={onToggleWeather}
        className="group flex items-center gap-3 px-5 py-3 rounded-xl bg-slate-900/90 backdrop-blur-sm border border-slate-700 hover:border-amber-500/50 hover:bg-slate-800/90 transition-all duration-200 shadow-lg hover:shadow-amber-500/10"
        data-testid="quick-access-weather"
      >
        <div className="p-2 rounded-lg bg-amber-500/20 group-hover:bg-amber-500/30 transition-colors">
          <CloudLightning className="w-5 h-5 text-amber-400" />
        </div>
        <div className="text-left">
          <div className="text-sm font-semibold text-slate-200">Weather Alerts</div>
          <div className="text-xs text-slate-500">NWS severe weather</div>
        </div>
      </button>

      {/* Ask Daisy Tile */}
      <button
        onClick={onOpenAiChat}
        className="group flex items-center gap-3 px-5 py-3 rounded-xl bg-slate-900/90 backdrop-blur-sm border border-slate-700 hover:border-purple-500/50 hover:bg-slate-800/90 transition-all duration-200 shadow-lg hover:shadow-purple-500/10"
        data-testid="quick-access-daisy"
      >
        <div className="p-2 rounded-lg bg-purple-500/20 group-hover:bg-purple-500/30 transition-colors">
          <MessageCircle className="w-5 h-5 text-purple-400" />
        </div>
        <div className="text-left">
          <div className="text-sm font-semibold text-slate-200">Ask Daisy</div>
          <div className="text-xs text-slate-500">AI safety assistant</div>
        </div>
      </button>
    </div>
  );
};

export default QuickAccessTiles;
